import { render } from "./TreatmentDetails.vue?vue&type=template&id=5df091b5"
import script from "./TreatmentDetails.vue?vue&type=script&lang=js"
export * from "./TreatmentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__